import {
  ConsultaParrillaGuiaSkyRequestEBM,
  ConsultaParrillaGuiaSkyRest_Entrada,
  ConsultaParrillaGuiaSkyRest_Parametros,
  ConsultaParrillaGuiaSkyRest_Respuesta,
  builtConsultaParrillaGuiaSkyRestEntrada,
  CanalW,
  EventosW,
} from "../Commons/Services/Parrilla";
//
import styles from "./guia.module.css";
import { ConsultaWS } from "../Commons/ServiciosBase";
import { useEffect, useState } from "react";
import { Epg, Layout } from "planby";
import { ChannelItem, ProgramItemComp, Timeline } from "../components";
import { Tarjeta } from "../Commons/Services/ConsultarIRD";
import {
  EjecutarRemoteBookingRest_Entrada,
  EjecutarRemoteBookingRest_Parametros,
  EjecutarRemoteBookingRest_Respuesta,
  builtEjecutarRemoteBookingRestInput,
  EjecutarRemoteBookingRequest,
} from "../Commons/Services/EjecutarRemoteBookingRest";
import {
  Col,
  Row,
  Container,
  Card,
  Button,
  Modal,
  Form,
  InputGroup,
  FormControl,
  FormLabel,
  FormGroup,
} from "react-bootstrap";

import skyOne from "../assets/img/Parrilla/sky_one.png";
import Loading from "../General/Loading";
import { Channel, Program } from "planby/dist/Epg/helpers/interfaces";
import { useApp } from "../useApp";
import encryptText from "../Commons/EncriptText";
import ConfirmMessage from "../General/ConfirmMessage";

type RemoteBookingModalData = {
  program: Program;
  title: string;
  channel: string;
  since: string;
  till: string;
  description: string;
  duration: string;
  index: number;
  image: string;
};

export type ServiceProgram = Program & {
  programIndex: number;
  numCanal: string;
  ratings: string;
};

/****** */
let fecha = new Date();

let dia = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
];

let mes = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
];

let fechaInicio =
  dia[fecha.getDate()] +
  "/" +
  mes[fecha.getMonth()] +
  "/" +
  fecha.getFullYear() +
  " " +
  fecha.toLocaleTimeString();

let fechaint = new Date();
let fechainte = new Date(fechaint);
let fechaFin =
  dia[fechainte.getDate()] +
  "/" +
  mes[fechainte.getMonth()] +
  "/" +
  fechainte.getFullYear() +
  " " +
  "23:59:59";

export class PaisOrigen {
  static CostaRica = "CR";
  static Guatemala = "GT";
  static Honduras = "HN";
  static Nicaragua = "NI";
  static Panama = "PA";
  static RepDom = "DO";
  static Mexico = "MX";
  static Salvador = "SV";
}

export class PaqTV {
  static VETV = "VETV";
  static PREPAGO = "PREPAGO";
  static BASICO = "BASICO";
  static FUN = "FUN";
  static FOX = "FOX";
  static HBO = "HBO";
  static UNIVERSE = "UNIVERSE";
  static FAMILIAR = "FAMILIAR";
  static TOTAL = "TOTAL";
  static GOLD = "GOLD";
  static PLATINUM = "PLATINUM";
  static BLACK = "BLACK";
  static BLUE = "BLUE";
  static PLUS = "PLUS";
  static ACCESS = "ACCESS";
  static MINI = "MINI";
  static SOLIDARIDAD = "SOLIDARIDAD";
  static SPORTS = "SPORTS";
  static SILVER = "SILVER";
  static COMBO = "COMBO";
}

const Guia = () => {
  const [esHD, setHD] = useState("");
  const [paqueteID, setPaqueteID] = useState("");
  const [status, setStatus] = useState("OK");
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");

  const [flujo, setFlujo] = useState(sessionStorage.getItem("flujos"));
  const myCuenta =
    flujo === "Sky+"
      ? sessionStorage.getItem("cuenta")!
      : sessionStorage.getItem("cuenta");
  var array: Tarjeta[] = JSON.parse(sessionStorage.getItem("tarjetas")!);

  const sampleRBData = {
    title: "Titulo",
    channel: "Canal 101",
    since: "09:00",
    till: "13:00",
    description: "Lorem ipsum",
  } as RemoteBookingModalData;

  const [refreshed, isRefreshed] = useState(false);

  const [nombrePaquete, setNombrePaquete] = useState(
    sessionStorage.getItem("flujos") !== "Sky+"
      ? sessionStorage.getItem("Paquete")
      : sessionStorage.getItem("PaqueteSky+")
  );

  const [codigoPais, setCodigoPais] = useState("");
  const [loading, itsLoading] = useState(false);
  const { isLoading, getEpgProps, getLayoutProps } = useApp();
  const [canales, setCanales] = useState<any>([]);

  const [step, setStep] = useState<number>(0);
  const [show, setShow] = useState(false);

  const [rbData, setrbData] = useState<RemoteBookingModalData>(sampleRBData);

  const [smartCard, setSmardCard] = useState<string>("");
  const [recordingType, setRecordingType] = useState<string>("");
  const [messageValidateField, setMessageValidateField] = useState("");

  const validarNulosYIndefinidios = (param: any) => {
    var retorno: string = "";
    if (param != null && typeof param != "undefined") {
      retorno = param;
    } else {
      retorno = "";
    }

    return retorno;
  };

  const determinarIdPaquete = (
    esHD: String,
    paquete: String,
    pais: String
  ): string => {
    let nombre = paquete.toUpperCase();

    if (pais.toUpperCase() == PaisOrigen.Mexico) {
      if (nombre.includes(PaqTV.PREPAGO) && nombre.includes(PaqTV.GOLD)) {
        return "78";
      }

      if (nombre.includes(PaqTV.VETV)) {
        let esPlus = nombre.includes(PaqTV.PLUS);
        if (esPlus && esHD == "Y") {
          return "14";
        } else if (esHD == "Y") {
          return "13";
        } else if (esPlus) {
          return "2";
        } else {
          return "1";
        }
      }

      if (esHD == "Y") {
        if (nombre.includes(PaqTV.PLATINUM)) {
          return "8";
        } else if (nombre.includes(PaqTV.FOX)) {
          return "9";
        } else if (nombre.includes(PaqTV.HBO)) {
          return "10";
        } else if (nombre.includes(PaqTV.BLACK)) {
          return "11";
        } else if (nombre.includes(PaqTV.GOLD)) {
          return "15";
        } else if (nombre.includes(PaqTV.SILVER)) {
          if (nombre.includes(PaqTV.COMBO)) {
            return "77";
          } else return "76";
        }
      } else {
        if (nombre.includes(PaqTV.ACCESS)) {
          return "3";
        } else if (nombre.includes(PaqTV.BASICO)) {
          return "4";
        } else if (nombre.includes(PaqTV.FUN)) {
          return "5";
        } else if (nombre.includes(PaqTV.HBO)) {
          return "6";
        } else if (nombre.includes(PaqTV.UNIVERSE)) {
          return "7";
        } else if (nombre.includes(PaqTV.FOX)) {
          return "12";
        } else if (nombre.includes(PaqTV.MINI)) {
          return "72";
        } else if (nombre.includes(PaqTV.SPORTS)) {
          return "72";
        } else if (nombre.includes(PaqTV.TOTAL)) {
          return "105";
        }
      }
    } else if (pais.toUpperCase() == PaisOrigen.CostaRica) {
      if (nombre.includes(PaqTV.VETV)) {
        return "16";
      } else if (nombre.includes(PaqTV.BASICO)) {
        return "17";
      } else if (nombre.includes(PaqTV.FUN)) {
        return "18";
      } else if (nombre.includes(PaqTV.FOX)) {
        return "19";
      } else if (nombre.includes(PaqTV.HBO)) {
        return "20";
      } else if (nombre.includes(PaqTV.UNIVERSE)) {
        return "21";
      } else if (nombre.includes(PaqTV.FAMILIAR)) {
        return "63";
      } else if (nombre.includes(PaqTV.GOLD)) {
        return "54";
      } else if (nombre.includes(PaqTV.PLATINUM)) {
        return "55";
      } else if (nombre.includes(PaqTV.BLACK)) {
        return "56";
      } else if (nombre.includes(PaqTV.SILVER)) {
        return "100";
      }
    } else if (pais.toUpperCase() == PaisOrigen.Guatemala) {
      if (nombre.includes(PaqTV.VETV)) {
        return "28";
      } else if (nombre.includes(PaqTV.BASICO)) {
        return "29";
      } else if (nombre.includes(PaqTV.FUN)) {
        return "30";
      } else if (nombre.includes(PaqTV.FOX)) {
        return "31";
      } else if (nombre.includes(PaqTV.HBO)) {
        return "32";
      } else if (nombre.includes(PaqTV.UNIVERSE)) {
        return "33";
      } else if (nombre.includes(PaqTV.FAMILIAR)) {
        return "65";
      } else if (nombre.includes(PaqTV.GOLD)) {
        return "57";
      } else if (nombre.includes(PaqTV.PLATINUM)) {
        return "58";
      } else if (nombre.includes(PaqTV.BLACK)) {
        return "59";
      } else if (nombre.includes(PaqTV.SILVER)) {
        return "101";
      }
    } else if (pais.toUpperCase() == PaisOrigen.Honduras) {
      if (nombre.includes(PaqTV.FAMILIAR)) {
        return "34";
      } else if (nombre.includes(PaqTV.TOTAL)) {
        return "35";
      } else if (nombre.includes(PaqTV.UNIVERSE)) {
        return "113";
      }
    } else if (pais.toUpperCase() == PaisOrigen.Nicaragua) {
      if (nombre.includes(PaqTV.VETV)) {
        return "36";
      } else if (nombre.includes(PaqTV.BASICO)) {
        return "37";
      } else if (nombre.includes(PaqTV.FUN)) {
        return "38";
      } else if (nombre.includes(PaqTV.FOX)) {
        return "39";
      } else if (nombre.includes(PaqTV.HBO)) {
        return "40";
      } else if (nombre.includes(PaqTV.UNIVERSE)) {
        return "41";
      } else if (nombre.includes(PaqTV.FAMILIAR)) {
        return "64";
      } else if (nombre.includes(PaqTV.FAMILIAR)) {
        return "64";
      }
    } else if (pais.toUpperCase() == PaisOrigen.Panama) {
      if (nombre.includes(PaqTV.VETV)) {
        return "42";
      } else if (nombre.includes(PaqTV.BASICO)) {
        return "43";
      } else if (nombre.includes(PaqTV.FUN)) {
        return "44";
      } else if (nombre.includes(PaqTV.FOX)) {
        return "45";
      } else if (nombre.includes(PaqTV.HBO)) {
        return "46";
      } else if (nombre.includes(PaqTV.UNIVERSE)) {
        return "47";
      } else if (nombre.includes(PaqTV.FAMILIAR)) {
        return "66";
      } else if (nombre.includes(PaqTV.GOLD)) {
        return "60";
      } else if (nombre.includes(PaqTV.PLATINUM)) {
        return "61";
      } else if (nombre.includes(PaqTV.BLACK)) {
        return "62";
      } else if (nombre.includes(PaqTV.SILVER)) {
        return "102";
      }
    } else if (pais.toUpperCase() == PaisOrigen.RepDom) {
      if (nombre.includes(PaqTV.VETV)) {
        return "48";
      } else if (nombre.includes(PaqTV.BASICO)) {
        return "49";
      } else if (nombre.includes(PaqTV.FUN)) {
        return "50";
      } else if (nombre.includes(PaqTV.FOX)) {
        return "51";
      } else if (nombre.includes(PaqTV.HBO)) {
        return "52";
      } else if (nombre.includes(PaqTV.UNIVERSE)) {
        return "53";
      } else if (nombre.includes(PaqTV.GOLD)) {
        return "68";
      } else if (nombre.includes(PaqTV.PLATINUM)) {
        return "69";
      } else if (nombre.includes(PaqTV.BLACK)) {
        return "70";
      } else if (nombre.includes(PaqTV.BLUE)) {
        return "71";
      } else if (nombre.includes(PaqTV.SILVER)) {
        return "103";
      }
    } else if (pais.toUpperCase() == PaisOrigen.Salvador) {
      if (nombre.includes(PaqTV.VETV)) {
        return "22";
      } else if (nombre.includes(PaqTV.BASICO)) {
        return "23";
      } else if (nombre.includes(PaqTV.FUN)) {
        return "24";
      } else if (nombre.includes(PaqTV.FOX)) {
        return "25";
      } else if (nombre.includes(PaqTV.HBO)) {
        return "26";
      } else if (nombre.includes(PaqTV.UNIVERSE)) {
        return "27";
      } else if (nombre.includes(PaqTV.FAMILIAR)) {
        return "67";
      } else if (nombre.includes(PaqTV.GOLD)) {
        return "73";
      } else if (nombre.includes(PaqTV.PLATINUM)) {
        return "74";
      } else if (nombre.includes(PaqTV.BLACK)) {
        return "75";
      } else if (nombre.includes(PaqTV.SILVER)) {
        return "104";
      }
    }

    return "0";
  };

  function handleSmartCardChange(e: React.ChangeEvent<HTMLSelectElement>) {
    setSmardCard(e.target.value);
    setMessageValidateField("");
  }

  function handleRecordingType(e: React.ChangeEvent<HTMLSelectElement>) {
    setRecordingType(e.target.value);
    setMessageValidateField("");
  }

  function refreshPage() {
    itsLoading(false);
    sessionStorage.setItem("parrillaRefresh", "Y");
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  }

  function invokeRemoteBookingModal(program: ServiceProgram) {
    array.map((item: Tarjeta) => {
      return (
        <option
          value={item.TarjetaInteligente}
          key={item.TarjetaInteligente}
          // Deshabilitar tarjetas que no soportan grabación
          /* disabled={
           item.Categoria !== 'SKY PLUS HD' &&
           // item.Categoria !== 'SKY MIXTO' &&
           item.Categoria !== 'SKY HMC PHD' &&
           item.Categoria !== 'SKY HMC UHD'
         }*/
        >
          {item.TarjetaInteligente}
        </option>
      );
    });

    setShow(true);
    var startDate = program.since;
    var endDate = program.till;
    var calcDuration = `${startDate.toString().match(/\d\d:\d\d/)}-${endDate
      .toString()
      .match(/\d\d:\d\d/)}`;

    setrbData({
      title: program.title,
      channel: program.channelUuid,
      since: program.start,
      till: program.end,
      description: program.description,
      duration: calcDuration,
      index: program.programIndex,
      image: program.image,
      program: program,
    } as RemoteBookingModalData);
  }

  const handleClose = () => {
    setStep(0);
    setShow(false);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
  };
  const handleShow = () => {
    setShow(true);
  };

  const doRecordRemoteBooking = async () => {
    setStep(1);
    let ejecutarRemoteBookingRequest: EjecutarRemoteBookingRequest = {
      IdentificadorCanalUnico: "5526",
      NumeroCuenta: myCuenta!,
      NumeroComercial: "120", /// idMostrado
      Grupo: "Remote Booking",
      Origen: "Web",
      UserName: `${sessionStorage.getItem("EmailNotif")}`,
      FechaInicio: "",
      OriginalNetwork: "162",
      Categoria: validarNulosYIndefinidios(nombrePaquete),
      TipoContenido: recordingType,
      ContentProvider: "1",
      TipoGrabacion: "ContenidoLegacy",
      SessionID: `${sessionStorage.getItem("idSesion")}`,
      Tipo: "Remote Booking", // se queda asi
      EventId: "375",
      Pais: codigoPais,
      FechaFin: "",
      TarjetaInteligente: smartCard!,
      Recordatorio: "N", // no
      SistemaOrigen: "AppSky", // app sky
      ProgramId: "443277",
      ContentId: "EP004432770000",
      Recurrencia: "",
      Duracion: "120",
      NombreEvento: "Tiempo de Filmoteca UNAM: Conversando con la muerte",
      NombreCanal: "TVUM",
      Operacion: "Solicitud Servicio Integrada",
      TransportStream: "114",
      SeriesId: "",
    };

    const EjecutarRemoteBookingRestDO: EjecutarRemoteBookingRest_Entrada =
      builtEjecutarRemoteBookingRestInput(ejecutarRemoteBookingRequest);
    let par = EjecutarRemoteBookingRest_Parametros(EjecutarRemoteBookingRestDO);
    let EjecutarRemoteBookingRestRespuesta: EjecutarRemoteBookingRest_Respuesta =
      await ConsultaWS(par);

    if (
      EjecutarRemoteBookingRestRespuesta.EBMHeaderResponse &&
      EjecutarRemoteBookingRestRespuesta.EBMHeaderResponse.ErrorNegocio
        .Estado == "ok" &&
      EjecutarRemoteBookingRestRespuesta.EBMHeaderResponse.ErrorTecnico.code ===
        "ok"
    ) {
      ////***** ejecutar lo que se debe realizar  */
      setStatus("OK");
      setMessage("El programa sera grabado con éxito");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    } else {
      setStatus("Error");
      setMessage(
        EjecutarRemoteBookingRestRespuesta.EBMHeaderResponse.ErrorNegocio
          .DescripcionError
      );
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);

      console.error(
        "error RemoteBookingRest",
        EjecutarRemoteBookingRestRespuesta.EBMHeaderResponse.ErrorNegocio
          .DescripcionError
      );
      /*setErrorCredenciales(true);

      setStatus("OK");
      setMessage(
        " Error : " +
          EjecutarRemoteBookingRestRespuesta.EBMHeaderResponse.ErrorNegocio
      );
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);*/
    }
    //----------------------------------------------------------------------------------------------------------------------------

    /**************Modificacion de contraseña  */

    setShow(false);
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);
  };

  const doObtenerProgramacion = async () => {
    if (
      sessionStorage.getItem("channels_parrilla") == undefined ||
      sessionStorage.getItem("programs_parrilla") == undefined
    ) {
      itsLoading(true);
    }

    setHD(validarNulosYIndefinidios(sessionStorage.getItem("banderaHD")));
    setNombrePaquete(
      validarNulosYIndefinidios(
        sessionStorage.getItem("flujos") !== "Sky+"
          ? sessionStorage.getItem("Paquete")
          : sessionStorage.getItem("PaqueteSky+")
      )
    );
    setCodigoPais(
      validarNulosYIndefinidios(
        sessionStorage.getItem("countryCode") == null
          ? "MX"
          : sessionStorage.getItem("countryCode")
      )
    );
    setPaqueteID(
      determinarIdPaquete(
        esHD,
        validarNulosYIndefinidios(nombrePaquete),
        codigoPais
      )
    );

    let consultaParrillaGuiaSkyRequestEBM: ConsultaParrillaGuiaSkyRequestEBM = {
      FECHA_FIN: fechaFin,
      FECHA_INICIO: fechaInicio,
      PAQUETE_ID: paqueteID,
    };

    const obtieneParrillaDO: ConsultaParrillaGuiaSkyRest_Entrada =
      builtConsultaParrillaGuiaSkyRestEntrada(
        consultaParrillaGuiaSkyRequestEBM
      );
    let ConsultaParrillaGuiaSkyRestParametros =
      ConsultaParrillaGuiaSkyRest_Parametros(obtieneParrillaDO);
    let obtieneParrillaRespuesta: ConsultaParrillaGuiaSkyRest_Respuesta =
      await ConsultaWS(ConsultaParrillaGuiaSkyRestParametros);

    setCanales(
      obtieneParrillaRespuesta.ConsultaParrillaGuiaSkyResponseEBM
        .Programaciones[0]?.Programacion
    );

    if (
      obtieneParrillaRespuesta.ConsultaParrillaGuiaSkyResponseEBM.Programaciones
        .length > 0 &&
      canales &&
      canales.length > 0
    ) {
      let arregloCanales: CanalW[] = [];
      let arregloEventos: EventosW[] = [];
      canales.forEach((item: any, index: number) => {
        if (index == 0) {
          arregloCanales.push({
            uuid: canales[index].Canal.IdMostrado,
            type: "channel",
            title: canales[index].Canal.CanalNombre,
            country: "",
            provider: canales[index].Canal.IdMostrado,
            logo:
              "https://qamiespaciosky.sky.com.mx/imagenes/guia/NewERA/" +
              canales[index].Canal.IdMostrado +
              "_H.png",
            year: 0,
            idCanal: canales[index].Canal.uuid,
          });
        }

        if (
          index > 0 &&
          canales[index - 1].Canal.IdMostrado != canales[index].Canal.IdMostrado
        ) {
          arregloCanales.push({
            uuid: canales[index].Canal.IdMostrado,
            type: "channel",
            title: canales[index].Canal.CanalNombre,
            country: "",
            provider: canales[index].Canal.IdMostrado,
            logo:
              "https://qamiespaciosky.sky.com.mx/imagenes/guia/NewERA/" +
              canales[index].Canal.IdMostrado +
              "_H.png",
            year: 0,
            idCanal: canales[index].Canal.uuid,
          });
        }
        arregloEventos.push({
          id: canales[index].Evento.EventId,
          description: canales[index].Evento.Sinopsis,
          title: canales[index].Evento.Titulo,
          isYesterday: true,
          since: canales[index].Evento.Fechainicio,
          till: canales[index].Evento.FechaFinal,
          channelUuid: canales[index].Canal.IdMostrado,
          image: canales[index].Canal.IdMostrado,
          country: "",
          Year: "",
          Rated: "",
          Released: "",
          Runtime: "",
          Genre: canales[index].Evento.Tipo,
          Director: "",
          Writer: "",
          Actors: "",
          Language: "",
          Country: "",
          Awards: "",
          Metascore: "",
          imdbRating: "",
          imdbVotes: "",
          imdbID: "",
          Type: canales[index].Evento.Tipo,
          totalSeasons: "",
          Response: "True",
          Ratings: canales[index].Canal.IdMostrado,
          rating: 0,
        });
      });

      arregloCanales.forEach((item: any, index: number) => {});

      arregloEventos.forEach((item: any, index: number) => {});
      let channels = arregloCanales;

      let eventos = arregloEventos;

      sessionStorage.setItem("channels_parrilla", JSON.stringify(channels));
      sessionStorage.setItem("programs_parrilla", JSON.stringify(eventos));

      itsLoading(false);
    }
  };

  useEffect(() => {
    if (
      sessionStorage.getItem("channels_parrilla") == undefined ||
      sessionStorage.getItem("programs_parrilla") == undefined
    ) {
      itsLoading(true);
      doObtenerProgramacion().then(() => {
        itsLoading(true);
      });
    } else {
      if (sessionStorage.getItem("parrillaRefresh") != "Y") {
        refreshPage();
      }
    }
  }, [doObtenerProgramacion]);

  return (
    <>
      <Loading isLoading={loading} />
      <Container fluid>
        <ConfirmMessage
          status={status}
          message={message}
          showAlert={showAlert}
        />
        <Row className={styles["headerRow"]}>
          <Col>
            <span className={styles["spectrum"]}>Guía De Programación</span>
            <p className={styles["title"]}>
              Revisa desde aquí toda tu programación disponible, ¡Puedes
              grabarlos desde aquí!
            </p>
          </Col>
        </Row>

        <div style={{ height: "80vh", width: "100%" }}>
          <Epg isLoading={isLoading} {...getEpgProps()}>
            <Layout
              {...getLayoutProps()}
              numberOfHoursInDay={25}
              renderTimeline={(props) => <Timeline {...props} />}
              renderProgram={({ program, ...rest }) => (
                <ProgramItemComp
                  doOnClick={() =>
                    invokeRemoteBookingModal(program.data as ServiceProgram)
                  }
                  key={program.data.id}
                  program={program}
                  {...rest}
                />
              )}
              renderChannel={({ channel }) => (
                <>
                  <Col>
                    <Row>
                      <ChannelItem
                        key={channel.uuid}
                        channel={channel}
                      ></ChannelItem>
                    </Row>
                  </Col>
                </>
              )}
            />
          </Epg>
        </div>
      </Container>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="border-0" closeButton></Modal.Header>
        <Modal.Body>
          {step === 0 ? (
            <>
              <p className={styles["modalTitle"]}>{rbData.title}</p>

              <p className={styles["modalSubtitle"]}>
                Canal {rbData.channel} | {rbData.duration}
              </p>
              <p className={styles["modalSubtitle"]}>{rbData.description}</p>
            </>
          ) : (
            <>
              <>
                <div
                  id="rbg-modal-header"
                  className={styles["w-full"] + " " + styles["modal-header"]}
                >
                  <h1 id="rbg-modal-title" className={styles["modalTitle"]}>
                    Grabación remota de un programa
                  </h1>
                  <h2 className={styles["modalSubtitle"]}>
                    Se grabará{" "}
                    <span className={styles["fontMedium"]}>{rbData.title}</span>{" "}
                    del{" "}
                    <span className={styles["fontMedium"]}>
                      canal {rbData.channel}
                    </span>
                  </h2>
                  {/*(messageValidateField || messageValidateField !== '') && (<>
                <p className="text-sm font-light mb-2 text-[#ef4444]">
                  {messageValidateField}
                </p></>
              )*/}
                </div>
                <div className="flex md:flex-row gap-4 flex-col w-full">
                  <div
                    id="rbg-form-remote-booking-card-input-container"
                    className="input-container w-full"
                  >
                    <label
                      htmlFor="rbg-form-remote-booking-card"
                      className={
                        styles["inputLabel"] + " " + styles["inputRequired"]
                      }
                    >
                      Tarjeta Inteligente
                    </label>

                    <select
                      id="rbg-form-remote-booking-card"
                      defaultValue={""}
                      name="TarjetaInteligente"
                      className={styles["inputSelect"] + " " + styles["w-full"]}
                      onChange={handleSmartCardChange}
                    >
                      <option value="" hidden disabled>
                        Seleccionar tarjeta
                      </option>
                      {array.map((item: Tarjeta) => {
                        return (
                          <option
                            value={item.TarjetaInteligente}
                            key={item.TarjetaInteligente}

                            // Deshabilitar tarjetas que no soportan grabación
                            /* disabled={
                               item.Categoria !== 'SKY PLUS HD' &&
                               // item.Categoria !== 'SKY MIXTO' &&
                               item.Categoria !== 'SKY HMC PHD' &&
                               item.Categoria !== 'SKY HMC UHD'
                             }*/
                          >
                            {item.TarjetaInteligente}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div
                    id="rbg-form-remote-booking-card-input-container"
                    className="input-container w-full"
                  >
                    <label
                      htmlFor="rbg-form-remote-booking-card"
                      className={
                        styles["inputLabel"] + " " + styles["inputRequired"]
                      }
                    >
                      Tipo de grabación
                    </label>

                    <select
                      id="rbg-form-remote-booking-card"
                      defaultValue={""}
                      name="TarjetaInteligente"
                      className={styles["inputSelect"] + " " + styles["w-full"]}
                      onChange={handleRecordingType}
                    >
                      <option value="" hidden disabled>
                        Tipo de grabación
                      </option>
                      <option value="Episodio">Episodio</option>
                      <option value="Serie">Serie</option>
                    </select>
                  </div>
                </div>
              </>
            </>
          )}

          {step === 0 ? (
            <>
              <div className={styles["divButton"] + " pt-4"}>
                <Button
                  className={styles["nextButton"]}
                  onClick={() => setStep(1)}
                >
                  <b>Siguiente</b>
                </Button>
              </div>
            </>
          ) : (
            <>
              <div className={styles["divButton"] + " pt-4"}>
                <Button
                  className={styles["nextButton"]}
                  onClick={() => doRecordRemoteBooking()}
                >
                  <b>Grabar Programa</b>
                </Button>
              </div>
            </>
          )}

          <div className={styles["divButton"]}>
            <Button className={styles["cancelButton"]} onClick={handleClose}>
              <b>Cancelar</b>
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Guia;
